import React from 'react';
import Head from 'next/head';
import { nextAsset } from '../../components/nextAsset';
import style from './BlogBase.module.scss';
import { IndexTop } from '../pages/index/IndexTop';
import { Footer } from '../../layouts/Footer';

export const BlogBase: React.FC<
  React.PropsWithChildren<{
    pageTitle: string;
    heroImage?: string;
    description?: string;
  }>
> = ({ children, heroImage, pageTitle, description }) => {
  const hero = heroImage ?? nextAsset('images/blog/hero-image.jpg');
  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta property="twitter:title" content={pageTitle} key="twitter-title" />
        <meta property="og:title" content={pageTitle} key="fb-title" />
        {description && <meta itemProp="description" content={description} key="itemProp-description" />}
        {description && <meta name="description" content={description} key="description" />}
        {description && <meta property="og:description" content={description} key="fb-description" />}
        {description && <meta property="twitter:description" content={description} key="twitter-description" />}
        <meta property="twitter:image" content={hero} key="twitter-image" />
        <meta property="og:image" content={hero} key="fb-image" />
        <meta itemProp="image" content={hero} key="image" />

        <link
          href="https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,400;0,700;1,400;1,700&display=swap"
          rel="stylesheet"
        />
      </Head>
      <IndexTop />
      <div className={style.blog}>{children}</div>
      <Footer />
    </>
  );
};
